'use strict'

var $ = require('jquery');
var prevInsertDetailsAfter = null;
var AnimationEasing = require('../lib/AnimationEasing.js');
var isAPersonActive = false;

function init() {
	var $personGroup = $('.peopleGroup--hasDetails, .scholarGroup--hasDetails');
	if ($personGroup.length === 0)
		return;

	var $body = $('body');

	// Clicking on not open will open and if already open will close
	$personGroup.on('click', '.card', function(event) {
		event.preventDefault();

		var $this = $(this);

		if ($this.hasClass('card--active') || ($this.find('.card__text').length === 0)) {
			var $detail = $('.card__reveal');
			collapse($detail, cleanup);
		} else {
			activate($this);
		}
	});

	// Close everything if resize
	$(window).resize(function() {
		cleanup();
	});

	// If click on anything when outside an open person
	$body.on('click', function(e) {
		if (isAPersonActive && e.target !== undefined) {
			var $this = $(e.target);
			if ($this.closest('.card').length == 0) {
				// Did not click on a person
				var $detail = $('.card__reveal');
				collapse($detail, cleanup);
			}
		}
	});

	function activate(element, event) {
		// Ensure no other .card is also marked active
		$('.card').removeClass('card--active');

		// Trigger GA event
		// element.trigger('analyticsEvent', $('.card__heading', element).text().trim()); // No longer does anything

		// Mark person active
		element.addClass('card--active');
		$('.peopleGroup .cards').addClass('cardSelected');
		$('.scholarGroup .cards').addClass('cardSelected');

		// Create detail area and populate it's contents
		var newContent = element.find('.card__heading, .card__text').clone();
		insertDetail(element, newContent);

		// Scroll to person
		var elementTop = element.offset().top;
		if ($body.scrollTop() < elementTop) {
			$body.stop(true).animate({
				'scrollTop': elementTop
			}, 300);
		}

		isAPersonActive = true;
	}

	function insertDetail(element, newContent) {

		// Find .card to insert after by finding when they drop to new column
		var insertDetailsAfter = element;
		var elementTop = element.offset().top;
		var result = element.nextAll('.card');
		for (var i = 0; i < result.length; i++) {
			if (result.eq(i).offset().top > elementTop) {
				break;
			} else {
				insertDetailsAfter = result.eq(i);
			}
		}

		var $detail = $('.card__reveal');
		if ($detail.length > 0) {
			// Already exists
			collapse($detail, function() {
				setup($detail, insertDetailsAfter); // Setup since we may need to move it in the DOM
				populate($detail, newContent);
				expand($detail);
			});
		} else {
			// New
			$detail = $('\
				<div class="card__reveal">\
					<div class="card__revealWrap">\
						<a class="card__revealClose">close</a>\
						<div class="card__revealContent"/>\
						<a class="card__revealClose">close</a>\
					</div>\
				</div>\
			');
			setup($detail, insertDetailsAfter);
			populate($detail, newContent);
			expand($detail);
		}
	}
}

function collapse($detail, complete) {
	$detail.stop(true).animate({
		height: 0
	}, {
		duration: 400,
		easing: 'easeInOutQuad',
		complete: complete,
	});
};

function expand($detail, complete) {
	var $contents = $('.card__revealWrap', $detail);
	var newHeight = $contents.outerHeight(true);

	// NOTE: Without requestanimiationframe the animate does not work on Android Samsung Galaxy table that runs old Android browser
	window.requestAnimationFrame(function() {
		$detail.stop(true).animate({
			height: newHeight
		}, {
			duration: 500,
			easing: 'easeInOutQuad',
			complete: complete,
		});

	});
};

function populate($detail, newContent) {
	// Populate with content
	var $contents = $('.card__revealContent', $detail);
	$contents.empty();
	$contents.append(newContent);
};

function setup($detail, insertDetailsAfter) {
	// Insert (or move)
	insertDetailsAfter.after($detail);
	prevInsertDetailsAfter = insertDetailsAfter;

	// Setup close
	$('.card__revealClose').on('click', function(e) {
		e.preventDefault();
		collapse($detail, cleanup);
	});
};

function cleanup() {
	isAPersonActive = false;

	$('.peopleGroup .card').removeClass('card--active');
	$('.peopleGroup .cards').removeClass('cardSelected');
	$('.peopleGroup .card__reveal').remove();

	$('.scholarGroup .card').removeClass('card--active');
	$('.scholarGroup .cards').removeClass('cardSelected');
	$('.scholarGroup .card__reveal').remove();
	prevInsertDetailsAfter = null;
}

var PeopleGroup = {
	init: init,
	cleanup: cleanup
};

module.exports = PeopleGroup;